import { MaterialIcon } from "components/ui/shared/MaterialIcon";
import styled from "styled-components";


export const PhasesProgressBar = ({phase = 'Reguleringsplan', onChange}) => {


    const width =   phase === "Forprosjekt" ? '0%' :
                    phase === "Kommunedelplan" ? '20%' :
                    phase === "Reguleringsplan" ? '40%' : 
                    phase === "Byggeplan" ? '60%' : 
                    phase === "Byggefase" ? '80%' : 
                    phase === "Annet" ? '0%' : '0%'

    return (
        <StyledPhasesProgressBar $width={width}>
            <PhasesProgressBarPhase
                onClick={() => onChange?.('Forprosjekt')}
                title="Forprosjekt"
                isActive={phase === "Forprosjekt" ? true : false}
                isDone={phase === "Kommunedelplan" || phase === "Reguleringsplan" || phase === "Byggeplan" || phase === "Byggefase" ? true : false}
            />

            <PhasesProgressBarPhase
                onClick={() => onChange?.('Kommunedelplan')}
                title="Kommunedelplan"
                isActive={phase === "Kommunedelplan" ? true : false}
                isDone={phase === "Reguleringsplan" || phase === "Byggeplan" || phase === "Byggefase" ? true : false}
            />

            <PhasesProgressBarPhase
                onClick={() => onChange?.('Reguleringsplan')}
                title="Reguleringsplan"
                isActive={phase === "Reguleringsplan" ? true : false}
                isDone={phase === "Byggeplan" || phase === "Byggefase" ? true : false}
            />

            <PhasesProgressBarPhase
                onClick={() => onChange?.('Byggeplan')}
                title="Byggeplan"
                isActive={phase === "Byggeplan" ? true : false}
                isDone={phase === "Byggefase" ? true : false}
            />

            <PhasesProgressBarPhase
                onClick={() => onChange?.('Byggefase')}
                title="Byggefase"
                isActive={phase === "Byggefase" ? true : false}
            />

            <PhasesProgressBarPhase
                onClick={() => onChange?.('Annet')}
                title="Annet"
                isActive={phase === "Annet"}
            />

            <div className="progressBar">
                <div/>
            </div>
        </StyledPhasesProgressBar>
    )
}

const StyledPhasesProgressBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: ${({theme}) => theme.spacing.xl};
    margin-right: ${({theme}) => theme.spacing.xl};
    position: relative;
    margin-bottom: ${({theme}) => theme.spacing.lg};

    div.progressBar
    {
        position: absolute;
        height: 4px;
        width: 100%;
        //border: 1px solid red;
        background: ${({theme}) => theme.colors.neutralPrimaryBorder};
        top: 50%;
        transform: translateY(-50%);
        z-index: -100;

        > div
        {
            height: 100%;
            width: ${({$width}) => $width};
            background: ${({theme}) => theme.colors.neutralSecondaryForeground};
            transition-duration: 220ms;
        }
    }
`

const PhasesProgressBarPhase = ({title, isActive, isDone, onClick}) => {
    return (
        <StyledPhasesProgressBarPhase
            onClick={onClick}
            className={isActive ? "isActive" : isDone ? "isDone" : null}
            data-title={title}
        >
            {
                isActive ? <div/>:
                isDone ? <MaterialIcon name="check"/> :
                null
            }
        </StyledPhasesProgressBarPhase>
    )
}

const StyledPhasesProgressBarPhase = styled.div`
    cursor: pointer;
    width: 34px;
    height: 34px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    gap: ${({theme}) => theme.spacing.md};
    width: 34px;
    height: 34px;
    border: 1px solid ${({theme}) => theme.colors.mutedForeground};
    border-radius: ${({theme}) => theme.cornerRadius.lg};
    outline: 3px solid ${({theme}) => theme.colors.neutralPrimaryBackground};
    background: ${({theme}) => theme.colors.neutralPrimaryBackground};

    > div
    {
        transition-duration: 2s;
        opacity: 0;
        width: 30%;
        height: 30%;
        border-radius: ${({theme}) => theme.cornerRadius.sm};
        background: ${({theme}) => theme.colors.neutralSecondaryForeground};
    }

    &::before
    {
        content: attr(data-title);
        position: absolute;
        
        
        bottom: 0;
        transform: translateY(calc(100% + ${({theme}) => theme.spacing.sm}));
    }

    &.isActive
    {
        border: 1px solid red;
        font-weight: 600;
        border: 1px solid ${({theme}) => theme.colors.neutralSecondaryForeground};
        
        > div, svg
        {
            opacity: 1;
        }
    }

    &.isDone
    {
        background: ${({theme}) => theme.colors.neutralSecondaryForeground};
        color: ${({theme}) => theme.colors.neutralPrimaryBackground};

        &::before
        {
            color: ${({theme}) => theme.colors.neutralSecondaryForeground};
        }

        .checkIcon
        {
            color: ${({theme}) => theme.colors.neutralSecondaryBackground};
        }

        > div, svg
        {
            opacity: 1;
        }
    }


`
